import { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
// import { useHistory } from "react-router-dom";
import * as Yup from 'yup';

import { ModelOfProduct, ModelOfProductBrand, ModelOfProductGroup, ModelOfProductSubgroup } from '../../database/index';

import api from '../../services/api';
import { useAuth } from 'src/contexts/auth';
import { useUploadController } from '../ImageUpload/UploadController';
import { useData } from 'src/contexts/data';
import { AxiosResponse } from 'axios';

export const useFormCreateProducts = () => {
	const { userAgencyId } = useAuth();
	const { imageUploading } = useData();
	const { handleUpload } = useUploadController();
	const [formDialog, setFormDialog] = useState(false);

	const [subgroupsData, setSubgroupsData] = useState<ModelOfProductSubgroup[]>([]);
	const [brandsData, setBrandsData] = useState<ModelOfProductBrand[]>([]);
	const [groupsData, setGroupsData] = useState<ModelOfProductGroup[]>([]);

	const [loading, setLoading] = useState<boolean>(false);
	const [productsResponse, setProductsResponse] = useState<AxiosResponse | null>(null);
	const [productsEditedResponse, setProductsEditedResponse] = useState<AxiosResponse | null>(null);
	const [selectedField, setSelectedField] = useState('');

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
		DESCRICAOCOMPLETA: Yup.string().required('* Campo obrigatório'),
		MARCA: Yup.string().required('* Campo obrigatório'),
		CODIGOBARRAS: Yup.string().required('* Campo obrigatório'),
		NCM: Yup.string().required('* Campo obrigatório'),
		AX_GRUPO: Yup.string().required('* Campo obrigatório'),
		AX_GRUPOSUB: Yup.string().required('* Campo obrigatório'),
		ULTIMOVALORCOMPRA: Yup.number()
			.typeError('O valor informado deve ser um número.')
			.required('* Campo obrigatório'),
		ULTIMOVALORVENDA: Yup.number()
			.typeError('O valor informado deve ser um número.')
			.required('* Campo obrigatório'),
	});

	useEffect(() => {
		console.log("-----> passei aqui: ",userAgencyId)
		const getBrands = async () => {
			api.get(`brands/${userAgencyId}`)
				.then(response => {
					setBrandsData(response.data);
				})
				.catch(err => {
					console.log(err);
				});
		};
		const getGroups = async () => {
			api.get(`groups/${userAgencyId}`)
				.then(response => {
					setGroupsData(response.data);
				})
				.catch(err => {
					console.log(err);
				});
		};
		const getSubgroups = async () => {
			api.get(`subgroups/${userAgencyId}`)
				.then(response => {
					setSubgroupsData(response.data);
				})
				.catch(err => {
					console.log(err);
				});
		};

		getBrands();
		getGroups();
		getSubgroups();
	}, []);

	const saveProduct = async (values: ModelOfProduct) => {
		setLoading(true);

		const newProduct: ModelOfProduct = {
			...values,
			ORGAO: userAgencyId,
			TIPOPRODUTO: 1,
			FOTO: 'foto',
		};

		if (!!productsResponse) {
			api.put(`products/${productsResponse.data.ID}`, newProduct)
				.then(response => {
					formik.resetForm();
					setProductsResponse(null);
					setProductsEditedResponse(response);
					setLoading(false);
					toast.current.show({
						severity: 'success',
						summary: 'Edição realizado',
						detail: 'O produto foi editado com sucesso!',
						life: 5000,
					});
				})
				.catch(err => {
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Edição não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		} else {

			console.log("Novo produto: ",newProduct);

			api.post('products', newProduct)
				.then(response => {
					setProductsResponse(response);
					setProductsEditedResponse(null);
					setLoading(false);
					handleUpload.processUploadFileImage(imageUploading, 'produto', 'AX_PRODUTO', response.data.ID);
					toast.current.show({
						severity: 'success',
						summary: 'Cadastro realizado',
						detail: 'Operação realizada com sucesso!',
						life: 5000,
					});
				})
				.catch(err => {
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Cadastro não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		}
	};

	const openFormDialog = async (field: string) => {
		setFormDialog(true);
		setSelectedField(field);
	};

	const closeFormDialog = () => {
		setFormDialog(false);
		setSelectedField('');
	};

	const formik = useFormik<ModelOfProduct>({
		initialValues: {
			ORGAO: '',
			DESCRICAO: '',
			DESCRICAOCOMPLETA: '',
			MARCA: '',
			FOTO: '',
			CODIGOBARRAS: '',
			NCM: '',
			AX_GRUPO: '',
			AX_GRUPOSUB: '',
			ULTIMOVALORCOMPRA: 0,
			ULTIMOVALORVENDA: 0,
			TIPOPRODUTO: 1,
		},
		onSubmit: async values => await saveProduct(values),
		validationSchema,
	});

	return {
		getController: {
			formik,
			loading,
			toast,
			formDialog,
			selectedField,
			productsResponse,
			productsEditedResponse,
			tablesData: {
				brandsData,
				groupsData,
				subgroupsData,
			},
		},
		handleController: {
			openFormDialog,
			closeFormDialog,
			setProductsResponse,
			setProductsEditedResponse,
		},
	};
};
